<template>
    <el-container>
      <el-aside id="leftNavBar" v-if="!hamburguerMenu">
        <LeftNavBar />
      </el-aside>
      <el-main>
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </el-main>
      <el-footer id="footer" v-if="!hiddenFooter">
        <Footer />
      </el-footer> 
    </el-container>
</template>

<script>
  import LeftNavBar from './LeftNavBar'
  import Footer from './Footer'

  export default {
    name: 'MainContainer',
    components: { LeftNavBar, Footer },
    data() {
      return {
        hamburguerMenu: false,
        hiddenFooter: false
      }
    },
    methods: {
      onResize() {
        if(window.innerWidth > 600)
          this.hamburguerMenu = false
        else
          this.hamburguerMenu = true
        
        if(window.innerWidth > 800)
          this.hiddenFooter = false
        else
          this.hiddenFooter = true
      }
    },
    mounted() {
    // Register an event listener when the Vue component is ready
    window.addEventListener('resize', this.onResize)
    this.onResize()
    },
    beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize)
    }
  }
</script>

<style scoped>
  #leftNavBar {
    min-height: calc(100vh - 40px);
  }

  .el-aside {
    background-color: #fdfdfd;
    box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.122);
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity 0.1s ease;
  }

  .fade-leave-active {
    transition: opacity 0.1s ease;
    opacity: 0;
  }
</style>

